import { render, staticRenderFns } from "./TransportationCreateEditModal.vue?vue&type=template&id=f4f05d48&scoped=true&"
import script from "./TransportationCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./TransportationCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TransportationCreateEditModal.vue?vue&type=style&index=0&id=f4f05d48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f05d48",
  null
  
)

export default component.exports